<pmv-main-content>
    <pmv-main-content-header title="Declaração de Acúmulo de Cargo Público" [subtitle]="subtitle">
        <pmv-loading [isLoading]="loading"></pmv-loading>
    </pmv-main-content-header>
</pmv-main-content>

<pmv-main-content-body>
    <div class="row" style="margin-bottom: 25px;;">
        <div class="col-xs-12">
            <h2> <span style="display: block;color:#2D699F;">{{editalAnoPss}}</span></h2>
            <br>
        </div>
    </div>

    <form #form="ngForm" validateOnSubmit (submit)="onSubmit(form)">
        <div class="row">
            Eu, <b> {{nomeCandidato}}</b>, CPF n° <b>{{cpfCandidato}}</b>, declaro para fins de posse do cargo
            de <b>{{cargoFuncaoCandidato}}</b>, que:
            <br>
            <br>

            <div class="form-group row">
                <div class="col-xs-12">
                    <pmv-checkbox name="confirmarNaoExerceValue" [(ngModel)]="campoConfirmaNaoExerce"
                        (click)="clickConfirmaNaoExerce()" [options]="checkboxVazioOptions" optionLabelField="label"
                        optionValueField="value" [disabled]="desabilitarNaoExerce">
                    </pmv-checkbox>
                    <strong>Não exerço</strong> qualquer outro cargo, função ou emprego em Órgão Público
                    Federal, Estadual ou Municipal, na Administração Direta ou Indireta, incluindo Autarquias,
                    Fundações, Empresas Públicas, Sociedades de Economia Mista e suas subsidiárias e sociedades
                    controladas, direta ou indiretamente, pelo Poder Público. Declaro que as informações são
                    verdadeiras.
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xs-12">

                    <pmv-checkbox name="confirmaExcerceValue" [(ngModel)]="campoConfirmaExerce"
                        [options]="checkboxVazioOptions" optionLabelField="label" optionValueField="value"
                        [disabled]="desabilitarExerce" (click)="clickConfirmaExerce()">
                    </pmv-checkbox>
                    <strong>Exerço</strong> o seguinte cargo/emprego público:
                </div>
            </div>
            <div>
                <fieldset header="" style="border: 1px Lightgrey solid; padding:10px;"
                    [disabled]="desabilitarCamposExerce">
                    <div>
                        <div class="col-md-4 col-xs-12">
                            <pmv-radio-button [(ngModel)]="dadosAcumulo.codigoEsfera"
                                name="nivelGovernamentalRadioButton" [options]="nivelGovernamentalOptions"
                                header="Esfera" optionLabelField="descricao" optionValueField="id">
                            </pmv-radio-button>
                        </div>
                        <div class="col-md-3 col-xs-12">
                            <pmv-datepicker name="dataAdmissaoAcumulo" label="Data de Admisão*" [showTime]="false"
                                [(ngModel)]="dadosAcumulo.dataAdmissao">
                            </pmv-datepicker>
                        </div>
                        <div class="col-md-5 col-xs-12">
                            <pmv-radio-button name="tipoDeVinculoRadioButton" [options]="tipoDeVinculoOptions"
                                header="Tipo de Vínculo" optionLabelField="descricao" optionValueField="id"
                                [(ngModel)]="dadosAcumulo.codigoTipoVinculo">
                            </pmv-radio-button>
                        </div>
                        <div class="col-xs-12">
                            <pmv-dropdown label="Nome do Órgão:" name="nomeOrgaoInput"
                                [options]="orgaosEntidadesExternasOptions" optionLabelField="descricao"
                                optionValueField="id" defaultOption=" " [disabled]="desabilitarCamposExerce"
                                [(ngModel)]="dadosAcumulo.codigoOrgaoVinculo">
                            </pmv-dropdown>
                        </div>
                        <div class="col-xs-12">
                            <pmv-input-text maxlength="100" name="cargoExerceInput" label="Cargo que exerce:"
                                [(ngModel)]="dadosAcumulo.cargoExerce">
                            </pmv-input-text>
                        </div>

                        <pmv-fieldset header="O servidor trabalha em regime de Escala/Plantão?" class="filtros-fieldset"
                            class="col-md-6 col-xs-12">
                            <div>
                                <pmv-radio-button name="regimeEscalaPlantaoRadioButton" [options]="simNaoOptions"
                                    header="" class="col-xs-6" id="temEscalaPlantao" optionLabelField="descricao"
                                    optionValueField="id" (change)="verificaEscalaPlantao($event)"
                                    [(ngModel)]="valorTrabalhaEscalaPlantao">
                                </pmv-radio-button>
                                <!-- <pmv-input-text maxlength="2" name="escalaPlantaoInput" label="Escala/Plantão:"
                                    [(ngModel)]="escalaPlantaoP1" type="number">
                                </pmv-input-text> -->
                                <pmv-mask (click)="$event.target.select()"
                                    [(ngModel)]="dadosAcumulo.descricaoEscalaPlantao" mask="99x99?9" class="col-xs-5"
                                    name="escalaPlantaoTipo2" label="Escala/Plantão:" [unmask]="false"
                                    [disabled]="desabilitarDescricaoEscalaPlantao"></pmv-mask>
                            </div>
                        </pmv-fieldset>
                        <div class="col-md-6 col-xs-12">
                            <!-- <pmv-input-text maxlength="20" name="cargaHorariaSemanalInput" type="number"
                                label="Carga Horário Semanal:" [(ngModel)]="dadosAcumulo.cargaHoraria">
                            </pmv-input-text> -->
                            <pmv-mask (click)="$event.target.select()" [(ngModel)]="dadosAcumulo.cargaHoraria" mask="99"
                                class="col-xs-4" name="cargaHorariaSemanalInput" label="Carga Horário Semanal:"
                                [unmask]="false">
                            </pmv-mask>
                            <div style="margin-top: 30px;">
                                Horas
                            </div>
                        </div>

                        <div class="col-xs-12" style="margin-top: 15px;">
                            <pmv-fieldset header="Horário de Trabalho Detalhado" class="filtros-fieldset">
                                <pmv-fieldset header="2° Feira" class="filtros-fieldset">
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d2e1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d2s1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d2e2">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d2s2">
                                        </pmv-input-text>
                                    </div>
                                </pmv-fieldset>
                                <pmv-fieldset header="3° Feira" class="filtros-fieldset">

                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d3e1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d3s1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d3e2">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d3s2">
                                        </pmv-input-text>
                                    </div>
                                </pmv-fieldset>
                                <pmv-fieldset header="4° Feira" class="filtros-fieldset">
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d4e1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d4s1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d4e2">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d4s2">
                                        </pmv-input-text>
                                    </div>
                                </pmv-fieldset>
                                <pmv-fieldset header="5° Feira" class="filtros-fieldset">
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d5e1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d5s1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d5e2">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d5s2">
                                        </pmv-input-text>
                                    </div>
                                </pmv-fieldset>
                                <pmv-fieldset header="6° Feira" class="filtros-fieldset">
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d6e1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d6s1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.d6e2">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.d6s2">
                                        </pmv-input-text>
                                    </div>
                                </pmv-fieldset>
                                <pmv-fieldset header="Sábado" class="filtros-fieldset">
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.dse1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.dss1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.dse2">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.dss2">
                                        </pmv-input-text>
                                    </div>
                                </pmv-fieldset>
                                <pmv-fieldset header="Domingo" class="filtros-fieldset">
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.dde1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.dds1">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Entrada:"
                                            type="time" [(ngModel)]="dadosAcumulo.dde2">
                                        </pmv-input-text>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <pmv-input-text maxlength="5" name="cargaHorariaSemanalInput" label="Saída:"
                                            type="time" [(ngModel)]="dadosAcumulo.dds2">
                                        </pmv-input-text>
                                    </div>
                                </pmv-fieldset>
                            </pmv-fieldset>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div style="margin-top: 15px;">
                <pmv-fieldset header="LICENÇAS" class="filtros-fieldset">
                    <pmv-radio-button name="perguntaEstaDeLicencaRadioButton"
                        [(ngModel)]="valorEstaLicencaDisponibilidade" [options]="simNaoOptions"
                        header="Estou em gozo de licença ou disponibilidade em outro cargo/emprego público?"
                        class="col-xs-12" optionLabelField="descricao" optionValueField="id"
                        (change)="verificaLicencaOuDisponibilidade($event)">
                    </pmv-radio-button>

                    <pmv-input-text maxlength="100" name="cargoLicencaInput" label="Cargo:" class="col-md-6 col-xs-12"
                        [(ngModel)]="dadosAcumulo.cargoLicenca" [disabled]="desabilitaCargoEhNomeOrgaoLicenca">
                    </pmv-input-text>

                    <pmv-input-text maxlength="150" name="orgaoLicencaInput" label="Nome Órgão:"
                        class="col-md-6 col-xs-12" [(ngModel)]="dadosAcumulo.orgaoLicenca"
                        [disabled]="desabilitaCargoEhNomeOrgaoLicenca">
                    </pmv-input-text>
                </pmv-fieldset>
            </div>
            <div class="col-xs-12" style="margin-top: 15px;">
                Em caso de Acúmulo ou Licença, é obrigatório anexar certidão ou declaração, conforme decreto
                n°17.953, de 20/12/2019.<br />
                Art. 1 º. Fica estabelecido que no ato da posse ou assinatura do contrato, o candidato que
                informar o acúmulo de cargo permitido, conforme o inciso XVI do Art. 37 da Constituição Federal,
                deverá entregar certidão/declaração devidamente assinada e carimbada pelo setor responsável pela
                área de Recursos Humanos do órgão onde o candidato já possui um vínculo, com as seguintes
                informações:<br />
                &emsp;I - nome do servidor;<br />
                &emsp;II - data de admissão;<br />
                &emsp;III - nome do cargo/função;<br />
                &emsp;IV - vínculo;<br />
                &emsp;V - jornada de trabalho;<br />
                &emsp;VI - horário de trabalho;<br />
                &emsp;VII - se trabalha em regime de escala ou não.<br /><br />

                Art. 2°. O candidato somente poderá tomar posse e/ou assinar contrato temporário de trabalho
                para exercer novo cargo/função, após a regularização da acumulação.<br />
            </div>
            <div class="col-xs-12" style="margin-top: 15px;">
                <p></p>
            </div>
            <div style="margin-top: 15px;">
                <pmv-fieldset header="APOSENTADORIA" class="filtros-fieldset">
                    <pmv-radio-button name="estaAposentadoRadioButton" [options]="simNaoOptions"
                        header="Estou aposentado(a) em outro cargo/emprego público?" class="col-xs-12"
                        optionLabelField="descricao" optionValueField="id" [(ngModel)]="valorEstaAposentado"
                        (change)="verificarAposentadoria($event)">
                    </pmv-radio-button>

                    <pmv-input-text maxlength="100" name="cargoAposentadoriaInput" label="Cargo:"
                        class="col-md-6 col-xs-12" [(ngModel)]="dadosAcumulo.cargoAposentadoria"
                        [disabled]="desabilitarCamposAposentadoria">
                    </pmv-input-text>

                    <pmv-input-text maxlength="100" name="orgaoAposentadoriaInput" label="Nome Órgão:"
                        class="col-md-6 col-xs-12" [(ngModel)]="dadosAcumulo.orgaoAposentadoria"
                        [disabled]="desabilitarCamposAposentadoria">
                    </pmv-input-text>

                    <pmv-radio-button name="aposentadoriaInvalidezRadioButton" [options]="simNaoOptions"
                        header="O referido provento é decorrente de aposentadoria por invalidez?" class="col-xs-12"
                        optionLabelField="descricao" optionValueField="id" style="margin-top: 15px;"
                        [(ngModel)]="valorAposentadoriaInvalidez" [disabled]="desabilitarCamposAposentadoria">
                    </pmv-radio-button>
                    <div class="col-xs-12 text-center" style="margin-top: 15px;">
                        <b>SE SIM, ANEXAR DOCUMENTO QUE COMPROVE A APOSENTADORIA, PORTARIA OU DECLARAÇÃO.</b>
                    </div>
                </pmv-fieldset>
            </div>

            <div style="margin-top: 15px;">
                <pmv-fieldset header="COMÉRCIO" class="filtros-fieldset">
                    <div class="form-group row">
                        <div class="col-xs-12">
                            <pmv-checkbox name="confirmarExerceComercioInfoValue" [(ngModel)]="campoExerceComercio"
                                [options]="checkboxVazioOptions" optionLabelField="label" optionValueField="value">
                            </pmv-checkbox>
                            <strong>Não exerço </strong>comércio, nem participo de sociedade comercial, na
                            qualidade de gerente, administrador ou
                            diretor, em empresa privada que mantenha relações administrativas ou comerciais com
                            o Município de Vitória.
                        </div>
                    </div>

                </pmv-fieldset>
            </div>

            <div style="margin-top: 15px;">
                <pmv-fieldset header=" " class="filtros-fieldset">
                    <div class="form-group row">
                        <div class="col-xs-12">
                            <pmv-checkbox name="confirmarTerLidoDeclacaoInfoValue"
                                [(ngModel)]="campoDeclaraConhecimento" [options]="checkboxVazioOptions"
                                optionLabelField="label" optionValueField="value">
                            </pmv-checkbox>
                            <b>Declaro</b>, ainda, que tomei conhecimento do inteiro teor das legislações abaixo
                            transcritas e que estou ciente de que estarei
                            sujeito às penalidades previstas em Lei, caso venha a incorrer em acumulação ilegal,
                            durante o exercício do cargo para o qual
                            fui empossado:

                            <p></p>
                            <strong>Art. 37 - CONSTITUIÇÃO FEDERAL</strong><br />
                            XVI - "É vedada a acumulação remunerada de cargos públicos, exceto, quando houver
                            compatibilidade de horários:<br>
                            &emsp;I. a de dois cargos de professor;<br>
                            &emsp;II. a de um cargo de professor com outro técnico ou científico;<br>
                            &emsp;III. a de dois cargos ou empregos privativos de profissionais de saúde, com
                            profissões regulamentadas; ”<br>
                            § 10. É vedada a percepção simultânea de proventos de aposentadoria decorrentes do
                            Art.
                            40 ou dos Art.42 e Art. 142 com a remuneração do
                            cargo, emprego ou função pública, ressalvados os cargos acumuláveis na forma desta
                            Constituição, os cargos eletivos e os cargos em comissão
                            declarados em lei de livre nomeação (Incluído pela Emenda Constitucional no 20, de
                            1998).<br>

                            <p></p>
                            <strong>LEI MUNICIPAL n° 6.753, de 16/11/2006 (Profissionais de Saúde).</strong><br />
                            Art.9° § 1°. Na acumulação de cargos na Prefeitura Municipal de Vitória deve ser
                            observada, além da compatibilidade de horário, a carga horária máxima de 60 horas.
                        </div>
                    </div>
                </pmv-fieldset>
            </div>

            <div class="col-md-12" style="text-align: right; padding: 5px 22px;">
                <button type="submit" class="btn btn-primary">Salvar</button>
                <button type="button" class="btn btn-warning" (click)="voltar()">Cancelar</button>
            </div>
        </div>
    </form>
</pmv-main-content-body>


// WEBPACK FOOTER //
// ./src/app/pages/candidato-convocado/acumuloCargo/declaracaoAcumuloCargo.component.html